
import { Category } from "@/script/apps/cms/entity/CmsEntity";
import bus from "@/script/core/util/Bus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { MenuData } from "@/script/core/base/MenuData";
import { ElLoading, ElMessage } from "element-plus";

@Options({})
export default class CategoryList extends BaseList {
  private queryEntity: Category = {};

  private dataList: Category[] = [];

  private service = new CategoryService();

  public initData(): ServiceContext {
    this.queryParam.pager = {
      pageIndex: 1,
      pageSize: 1000,
      total: 0,
      sorters: [{ prop: "sortNo", sortField: "cc.sort_no", sortMode: "desc" }],
    };
    return ServiceFactory.build(
      "biz_cms_category",
      "/cms/category",
      "/cms/category",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    return this.queryEntity;
  }

  addChild(scope: any) {
    const id = scope.row.id;
    this.$router.push({
      path: this.serviceContext.detailUrl,
      query: { id: 0, type: "A", cache: "0", parentId: id },
    });
    const menuData: MenuData = {
      name: String(this.serviceContext.listUrl),
      path: String(this.serviceContext.detailUrl),
      query: { type: "A", cache: "1" },
      isClose: true,
    };
    bus.emit("to-detail", menuData);
  }

  public afterLoadList(data: any): void {
    const dataList: Category[] = data.list as Category[];
    dataList.forEach((item) => {
      item.staticizeName = item.staticize ? "启用" : "禁用";
      item.navName = item.nav ? "是" : "否";
    });

    const dataTree: Category[] = [];
    dataList.forEach((item) => {
      if (!item.parentId) {
        item.childCategorys = [];
        dataTree.push(item);
        this.generateTree(dataList, item);
      }
    });
    this.dataList = dataTree;
  }

  private generateTree(dataList: Category[], parent: Category) {
    const childs: Category[] = [];
    dataList.forEach((item) => {
      if (item.parentId === parent.id) {
        childs.push(item);
        // 递归
        this.generateTree(dataList, item);
      }
    });
    if (childs.length > 0) {
      parent.childCategorys = childs;
    }
  }

  private fullStaticize() {
    const loading = ElLoading.service({
      lock: true,
      text: "全站静态化执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.service.fullStaticize().then(
      (result: any) => {
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("全站静态化失败，失败原因：" + error.message);
      }
    );
  }

  private staticize() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要静态化的栏目！");
      return;
    }
    const ids: number[] = [];
    this.selectedList.forEach((item) => {
      ids.push(item.id!);
    });

    const loading = ElLoading.service({
      lock: true,
      text: "静态化执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.service.staticize(ids).then(
      (result: any) => {
        (this.$refs.table as any).clearSelection();
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("静态化失败，失败原因：" + error.message);
      }
    );
  }

  private dynamic() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要动态化的栏目！");
      return;
    }
    const ids: number[] = [];
    this.selectedList.forEach((item) => {
      ids.push(item.id!);
    });

    const loading = ElLoading.service({
      lock: true,
      text: "动态化执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.service.dynamic(ids).then(
      (result: any) => {
        this.selectedList = [];
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("动态化失败，失败原因：" + error.message);
      }
    );
  }
}
